import React from "react";
import Home from "./components/home/Home";
import ThemeProvider from "./settings/theme/ThemeProvider";
import global from "./settings/theme/global";
import { Global } from "@emotion/react";

const App = () => (
  <ThemeProvider>
    <Global styles={global} />
    <Home />
  </ThemeProvider>
);

export default App;
